<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBPriceListForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBPriceListList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBPriceListForm from './Form.vue'

export default {
  components: {
    EXSBPriceListForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbpricelist/update/isLoading',
      error: 'exsbpricelist/update/error',
      deleteError: 'exsbpricelist/del/error',
      deleteLoading: 'exsbpricelist/del/isLoading',
      created: 'exsbpricelist/create/created',
      deleted: 'exsbpricelist/del/deleted',
      retrieved: 'exsbpricelist/update/retrieved',
      updated: 'exsbpricelist/update/updated',
      violations: 'exsbpricelist/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBPriceListList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbpricelist/create/reset',
      deleteItem: 'exsbpricelist/del/del',
      delReset: 'exsbpricelist/del/reset',
      retrieve: 'exsbpricelist/update/retrieve',
      updateReset: 'exsbpricelist/update/reset',
      update: 'exsbpricelist/update/update',
      updateRetrieved: 'exsbpricelist/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbpricelist ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
